<template>
  <div class="page-content">
    <div class="content-wrapper">
      <!-- Page header -->
      <div class="page-header mb-2">
        <div class="page-header-content header-elements-md-inline">
          <div class="page-title d-flex">
            <h4 class="font-weight-semibold">Sensitive Area Keywords</h4>
          </div>
        </div>
      </div>
      <!-- /page header -->

      <!-- Content area -->
      <div class="content pt-0">
        <div class="row mb-2">
          <div class="col-12">
            <div class="card p-2">
              <div >
                <h5 class="font-weight-semibold" v-if="mode ==='edit'">Edit Keyword</h5>
                <h5 class="font-weight-semibold" v-else>Create Keyword</h5>
                <hr class="p-0">
              </div>
              <b-form autocomplete="off">
                <b-form-group>
                  <label for="name">Sensitive Area Name</label>
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    type="text"
                    placeholder="Enter sensitive area name"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group>
                  <label for="tags-basic"
                    >Type a new keyword and press enter</label
                  >
                  <b-form-tags
                    input-id="tags-basic"
                    v-model="form.keywords"
                    placeholder="Add keyword"
                  ></b-form-tags>
                </b-form-group>

                <b-form-group class="text-right">
                  <button type="button" class="btn btn-primary" @click="createKeyword" v-if="mode ==='create'">Create</button>
                  <button type="button" class="btn btn-success mr-1" @click="updateKeyword" v-if="mode ==='edit'">Save</button>
                  <button type="button" class="btn btn-danger" @click="onCancel" v-if="mode ==='edit'">Cancel</button>
                </b-form-group>
              </b-form>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Keywords</th>
                      <th>Created at</th>
                      <th>Updated at</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isLoading">
                      <td colspan="8">
                        <loading></loading>
                      </td>
                    </tr>
                    <tr v-else v-for="(group, idx) in groups" :key="group._id">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ group.name }}</td>
                      <td>{{ group.keywords.join(", ") }}</td>
                      <td>
                        {{ moment(group.createdAt).format('DD/MM/YYYY HH:mm') }}
                      </td>
                      <td>
                        {{ moment(group.updatedAt).format('DD/MM/YYYY HH:mm') }}
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn"
                          @click="editGroup(group)"
                        >
                          <i class="far fa-edit"></i>
                        </button>

                        <button
                          type="button"
                          class="btn"
                          @click="deleteGroup(group._id)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /content area -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import serviceRoutes from '../service-routes'
import { BForm, BFormTags, BFormInput, BFormGroup } from 'bootstrap-vue'
import Loading from '../components/Loading'

export default {
  components: { BForm, BFormTags, Loading, BFormInput, BFormGroup },
  data () {
    return {
      isLoading: true,
      groups: [],
      pageName: '',
      form: {
        id: '',
        name: '',
        keywords: []
      },
      mode: 'create' // create/edit

    }
  },
  async mounted () {
    await this.init()
    this.isLoading = false
  },
  methods: {
    moment,
    async init () {
      let res = await serviceRoutes.getAllSensitiveAreaKeyword()
      this.groups = res.data.data
    },
    async createKeyword () {
      serviceRoutes
        .createSensitiveAreaKeyword({
          name: this.form.name,
          keywords: this.form.keywords
        })
        .then(() => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Keyword was added',
            showConfirmButton: false,
            showCloseButton: true
          })
          this.init()
          this.resetForm()
        })
        .catch(error => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: error.response.data.message,
            showConfirmButton: false,
            showCloseButton: true
          })
        })
    },
    async updateKeyword () {
      serviceRoutes
        .updateSensitiveAreaKeyword(this.form.id, {
          name: this.form.name,
          keywords: this.form.keywords
        })
        .then(() => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Keyword was added',
            showConfirmButton: false,
            showCloseButton: true
          })
          this.init()
          this.resetForm()
        })
        .catch(error => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: error.response.data.message,
            showConfirmButton: false,
            showCloseButton: true
          })
        })
    },
    async deleteGroup (id) {
      this.$swal({
        // toast: true,
        position: 'center',
        icon: 'warning',
        title: 'Do you want to delete this?',
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true
      }).then(async result => {
        if (result.value) {
          serviceRoutes.deleteSensitiveAreaKeyword(id).then(() => {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: 'Delete success',
              showConfirmButton: false,
              showCloseButton: true
            })
            this.resetForm()
          })
            .catch(error => {
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response.data.message,
                showConfirmButton: false,
                showCloseButton: true
              })
            })
          this.init()
        }
      })
    },
    resetForm () {
      this.form = {
        id: '',
        name: '',
        keywords: []
      }
      this.mode = 'create'
    },
    onCancel () {
      this.resetForm()
    },
    editGroup (group) {
      this.mode = 'edit'
      const { _id, name, keywords } = group
      this.form = { id: _id, name, keywords }
      document.querySelector('.content-wrapper').scrollTop = 0
    }
  }
}
</script>
